import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 * Fires on the sitter profile revamp when the "Pets sitter can host" / "Pets sitter
 * can care for" accordion section is expanded.
 *
 * &nbsp;
 */
export class SitterProfilePetsSitterCanHostExpandEvent extends AnalyticsEvent {
  eventName = 'sitter-profile-pets-sitter-can-host-expand';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.provider_profile;
}
